import { LogLevel } from "@azure/msal-browser";

const AzureActiveDirectoryAppClientId = process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID;
const AzureAuthority = process.env.REACT_APP_AZURE_AUTHORITY;
export const MSAL_CONFIG = {
  auth: {
    clientId: AzureActiveDirectoryAppClientId,
    authority: `https://login.microsoftonline.com/${AzureAuthority}`,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};
